import {
  ATTENTION_ITEMS,
  BEHAVIOR_ITEMS,
  CAREGIVER_ITEMS,
  CaregiverItem,
  EMOTIONAL_ITEMS,
  PscItem
} from "./scoring";

export type SectionTheme = "attention" | "emotional" | "behavior" | "parenting";

export type SectionDefinition = {
  readonly theme: SectionTheme;
  readonly title: string;
  readonly prompt: string;
  readonly scale: "psc" | "likert";
  readonly nextLabel: string;
};

export const SECTION_DEFINITIONS: readonly SectionDefinition[] = [
  {
    theme: "attention",
    title: "Attention & focus",
    prompt: "How often in the past month has your child...",
    scale: "psc",
    nextLabel: "Next →"
  },
  {
    theme: "emotional",
    title: "Emotional wellbeing",
    prompt: "How often in the past month has your child...",
    scale: "psc",
    nextLabel: "Next →"
  },
  {
    theme: "behavior",
    title: "Behavior & conduct",
    prompt: "How often in the past month has your child...",
    scale: "psc",
    nextLabel: "Next →"
  },
  {
    theme: "parenting",
    title: "Parenting & caregiver wellbeing",
    prompt: "How much do you agree with each statement?",
    scale: "likert",
    nextLabel: "View results →"
  }
];

export const SECTION_PSC_ITEMS: readonly (readonly PscItem[])[] = [
  ATTENTION_ITEMS,
  EMOTIONAL_ITEMS,
  BEHAVIOR_ITEMS
];

export const CAREGIVER_SECTION_ITEMS: readonly CaregiverItem[] = CAREGIVER_ITEMS;

export const SECTION_COUNT = SECTION_DEFINITIONS.length;
